<template>
	<FilterComponent
		:title="'Planos'"
		:open="openFilter"
		:fields="filterFields"
		@apply-filters="handleFilters"
		@update-open="openFilter = false"
    />

	<PlanosCommonForm 
		:title="'Novo Plano'"
		:open= "newOpen"
		:resetFormData= "resetFormData"
		:inputsList="inputs"
		@data="onSendFormData"
		@update-open="newOpen = false"
	/>

	<PlanosCommonForm 
		:title="'Editar Plano'"
		:open= "editOpen"
		:resetFormData= "resetFormData"
		:inputsList="inputs"
		:placeHolderValues= "editFormData"
		@editing-data= "onSendEditingData"
		@update-open= "editOpen = false"
	/>
	<Commonlisting
		:listingData = "data"
		:headersData = "headers"
		:headerInfo = "headerInfo"
		:previous = "previous"
		:next = "next"
		:inputsListing= "inputs"
		:currentPage = "currentPage"
		:totalPages = "totalPages"
		:totalRecords = "totalRecords"
		:resetFormData= "resetFormData"
		:editFormData= "editFormData"
		:importFile= "false"
		:useForms= "false"
		:fileOnly= "false"
		@previous-page= "pageData"
		@next-page= "pageData"
		@go-to-page= "goTo"
		@find-by-field= "filtered"
		@clean-filter= "cleanFilter"
		@send-form-data= "onSendFormData"
		@delete-data-id= "deleteData"
		@edit-alternative= "getEditData"
		@new-alternative="newEntry"
		@view-confirmation= "getEditData"
		@filter="openFilter = true"
		:customActions="customActions"
		@acao-customizada="handleCustomAction"
	/>
	
	<MatrizesUploadModal
		:open="matrizesOpen"
		:planoId="selectedPlanoId"
		@update-open="matrizesOpen = false"
	/>

	<MatrizesVisualizarModal
		:open="matrizesVisOpen"
		:planoId="selectedPlanoId"
		@update-open="matrizesVisOpen = false"
	/>

	<CommonLoading
		v-if="loading"
	/>
	
</template>
<script>
import Commonlisting from '@/components/generalcomponents/CommonListing';
import PlanosRepository from '@/services/PlanosRepository.vue';
import { pageVariables } from '@/views/insideviews/planos/PageVariablesPlanos';
import { handleUnauthorized } from '@/services/AuthSer/authServiceFunction';
import FilterComponent from "@/components/generalcomponents/CommonFilter.vue";
import Swal from "sweetalert2";
import CommonLoading from '@/components/generalcomponents/CommonLoading.vue';
import PlanosCommonForm from './PlanosCommonForm.vue';
import MatrizesUploadModal from '@/components/generalcomponents/MatrizesUploadModal.vue';
import MatrizesVisualizarModal from '@/components/generalcomponents/MatrizesVisualizarModal.vue';

export default {
	name: 'PlanosView',
	async created(){
		this.onlineUser = JSON.parse(window.localStorage.getItem("myUser") || "{}");
		this.pageData(this.planosFilterPage)
	},
	data() {
		return {
			...pageVariables,
			data: [],
			previous: '',
			next: '',
			totalPages: 0,
			totalRecords: 0,
			currentPage: 0,
			resetFormData: false,
			editFormData:{},
			newOpen: false,
			editOpen: false,
			openFilter: false,
			filters: [],
			filterFields: [
				{
					name: "nome",
					label: "Nome",
					type: "input",
					placeholder: "Digite o nome do plano"
				},
				{
					name: "empresa",
					label: "Empresa Relacionada",
					type: "input",
					placeholder: "Busque pela empresa associada ao plano"
				},
				{
					name: "seguradora",
					label: "Seguradora Relacionada",
					type: "input",
					placeholder: "Busque pela seguradora associada ao plano"
				},
			],
			onlineUser: JSON.parse(window.localStorage.getItem("myUser")),
			matrizesOpen: false,
			matrizesVisOpen: false,
			selectedPlanoId: 0,
			customActions: [
				{ nome: 'Importar Matriz Reenq.', field: 'id' },
				{ nome: 'Visualizar Matriz Reenq.', field: 'id' }
			]
		};
	},
	props: {
	},
	methods: {
		handleCustomAction(actionData) {
			this.selectedPlanoId = actionData.data;
			if (actionData.nome === 'Importar Matriz Reenq.') {
				this.matrizesOpen = true;
			} else if (actionData.nome === 'Visualizar Matriz Reenq.') {
				this.matrizesVisOpen = true;
			}
		},
		async pageData(page){
			this.loading = true; 
			const planoRepo = new PlanosRepository();
			try {
				const response = await planoRepo.getPlanos(this.onlineUser.token,page,this.filters);
				if (response?.status  === 200) {
					this.data = response.data.data;
					this.totalPages = response.data.last_page;
					this.totalRecords = response.data.total;
					this.currentPage = response.data.current_page;

				if (response.data.next_page_url) {
					this.next = response.data.next_page_url;
				}else{
					this.next = ""
				}
				if (response.data.prev_page_url) {

					this.previous = response.data.prev_page_url;
				}else{
					this.previous = ""
				}
				this.loading = false; 

				}
			} catch (error) {
				this.loading = false;
				this.mostrarAlertaErro(error);
				handleUnauthorized(error); 
			}
		},
		newEntry(){
			this.newOpen = true
		},
		async onSendFormData(data){
			this.loading = true; 
			const planoRepo = new PlanosRepository();
			try {
				const response = await planoRepo.createPlano(this.page,data,this.onlineUser.token);
				if (response?.status === 200) {
					this.pageData(this.planosFilterPage);
					this.resetForm();
					this.mostrarAlerta();
					this.newOpen = false;
					this.loading = false; 
				} else {
					this.newOpen = false;
					this.error = response?.message;
					this.mostrarAlertaErro(this.error);
					this.loading = false;
				}
			} catch (error) {
				this.newOpen = false;
				this.loading = false;
				this.mostrarAlertaErro(error);
				handleUnauthorized(error);
			}	
		},
		async onSendEditingData(data,id){
			this.loading = true; 
			const planoRepo = new PlanosRepository();
			try {
				const response = await planoRepo.updatePlano(this.page,this.onlineUser.token,id,data);
				if (response?.status === 200) {
					this.pageData(this.planosFilterPage);
					this.mostrarAlerta();
					this.loading = false; 
				} else {
					this.loading = false; 
					this.error = response?.message;
					this.mostrarAlertaErro(this.error);
				}
			} catch (error) {
				this.loading = false; 
				this.mostrarAlertaErro(error);
				handleUnauthorized(error);
			}	
		},
		async deleteData(id){
			this.loading = true; 
			const planoRepo = new PlanosRepository();
			try {
				const response = await planoRepo.deletePlano(this.page,this.onlineUser.token,id);
				if (response?.status === 200) {
					this.loading = false; 
					this.mostrarAlerta();
					this.pageData(this.planosFilterPage);

				} else {
					this.loading = false; 
					this.error = response?.message;
					this.mostrarAlertaErro(this.error);
				}
			} catch (error) {
				this.loading = false; 
				handleUnauthorized(error);
				this.mostrarAlertaErro(error);
			}	
		},
		async getEditData(id){
			this.loading = true;
			const planoRepo = new PlanosRepository();
			try {
				const response = await planoRepo.getPlano(this.page,this.onlineUser.token,id);
				if (response?.status === 200) {
					this.editFormData = response.data;
					this.editOpen = true; // <-- Habilita a abertura do modal de edição
					this.loading = false; 
				} else {
					this.error = response?.message;
					this.loading = false; 
					this.mostrarAlertaErro(this.error);
				}
			} catch (error) {
				this.loading = false; 
				this.mostrarAlertaErro(error);
				handleUnauthorized(error);
			}	
		},
		goTo(number){
			this.pageData(this.planosFilterPage+"?page="+number)
		},
		filtered(filteredData){
			const key = this.seachFilterKey;
			const value = filteredData;
			if (key) {
				this.pageData(this.planosFilterPage+"?"+key+'='+value);
			}
		},
		cleanFilter(){
			this.pageData(this.planosFilterPage)	
		},
		
		resetForm() {
			this.resetFormData = true;
			this.$nextTick(() => {
				this.resetFormData = false;
			});
		},

		handleFilters(rawFilters){
			console.log(rawFilters)
			this.filters = rawFilters;
			this.openFilter = false;
			this.pageData(this.planosFilterPage);
		},

		mostrarAlerta() {
			Swal.fire({
				icon: 'success',
				title: 'Sucesso!',
				text: 'A operação foi concluída com sucesso.',
				confirmButtonColor: '#3085d6', 
			});
		},

		mostrarAlertaErro(message) {
			Swal.fire({
				icon: 'error',
				title: 'Erro!',
				text: message,
				confirmButtonColor: '#3085d6', 
			});
		},
	},
	components:{
		Commonlisting,
		FilterComponent,
		CommonLoading,
		PlanosCommonForm,
		MatrizesUploadModal,
		MatrizesVisualizarModal
	},
	setup() {
	return {
	}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
